export const currencies = [
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ANG",
    "AOA",
    "ARS",
    "AUD",
    "AWG",
    "AZN",
    "BAM",
    "BBD",
    "BDT",
    "BGN",
    "BHD",
    "BIF",
    "BMD",
    "BND",
    "BOB",
    "BRL",
    "BSD",
    "BTN",
    "BWP",
    "BYN",
    "BZD",
    "CAD",
    "CDF",
    "CHF",
    "CLP",
    "CNY",
    "COP",
    "CRC",
    "CUP",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EGP",
    "ERN",
    "ETB",
    "EUR",
    "FJD",
    "FKP",
    "FOK",
    "GBP",
    "GEL",
    "GGP",
    "GHS",
    "GIP",
    "GMD",
    "GNF",
    "GTQ",
    "GYD",
    "HKD",
    "HNL",
    "HRK",
    "HTG",
    "HUF",
    "IDR",
    "ILS",
    "IMP",
    "INR",
    "IQD",
    "IRR",
    "ISK",
    "JEP",
    "JMD",
    "JOD",
    "JPY",
    "KES",
    "KGS",
    "KHR",
    "KID",
    "KMF",
    "KRW",
    "KWD",
    "KYD",
    "KZT",
    "LAK",
    "LBP",
    "LKR",
    "LRD",
    "LSL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MNT",
    "MOP",
    "MRU",
    "MUR",
    "MVR",
    "MWK",
    "MXN",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "OMR",
    "PAB",
    "PEN",
    "PGK",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SBD",
    "SCR",
    "SDG",
    "SEK",
    "SGD",
    "SHP",
    "SLE",
    "SOS",
    "SRD",
    "SSP",
    "STN",
    "SYP",
    "SZL",
    "THB",
    "TJS",
    "TMT",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TVD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "USD",
    "UYU",
    "UZS",
    "VES",
    "VND",
    "VUV",
    "WST",
    "XAF",
    "XCD",
    "XOF",
    "XPF",
    "YER",
    "ZAR",
    "ZMW",
    "ZWL",
]; // ISO 4217 currency codes as of 2024
// TODO: choose a pattern to load the latest ISO 4217 currency codes dynamically from an endpoint or file. Can use a redux store or a context provider

export const countryCurrencies = { CA: "CAD", US: "USD", UK: "GBP", GB: "GBP" };
export const month_abbr = [
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
];
export const quarter_abbr = ["Q1", "Q2", "Q3", "Q4"];

// Features
export const FEATURE_KEEP_PROFILES_PRIVATE = "keep_profiles_private";
export const FEATURE_BID_APPROVAL_FLOW = "bid_approval_flow";
export const FEATURE_VIEW_TRAINING_LINK = "view_training_link";
export const FEATURE_VIEW_HELP_LINK = "view_help_link";
export const FEATURE_VIEW_MAKERS_LINKS = "view_makers_links";
export const FEATURE_CREATE_ORGANIZATION = "create_organization";
export const FEATURE_LEAVE_ORGANIZATION = "leave_organization";
export const FEATURE_MULTI_LEGAL_ENTITY = "multi_legal_entity";
export const FEATURE_VIEW_BID_GOALS = "view_bid_goals";
export const FEATURE_PROJECT_STATUS_FLOW = "project_status_flow";
export const FEATURE_MULTI_PERSON = "multi_person";
export const FEATURE_BIDS = "bids";
export const FEATURE_VENDORS = "vendors";
export const FEATURE_INVOICES = "invoices";
export const FEATURE_COMMUNITY = "community";
export const FEATURE_GENERAL_TEMPLATES = "general_templates";
export const FEATURE_CLIENT_OWNER = "client_owner";
export const FEATURE_PROJECT_OWNER = "project_owner";
export const FEATURE_PROJECT_TYPE = "project_type";
export const FEATURE_PROJECT_FORECAST = "project_forecast";
export const FEATURE_PROJECT_INTERNAL_BUDGET = "project_internal_budget";
export const FEATURE_BID_XODOSIGN = "bid_xodosign";
export const FEATURE_AI_INTAKE = "ai_intake";

// Features (Strategy)
export const FEATURE_ACCOUNTING_STRATEGY = "accounting_strategy";
export const FEATURE_STORAGE_STRATEGY = "storage_strategy";
export const FEATURE_CONTRACT_STRATEGY = "contract_strategy";
export const FEATURE_RESOURCING_STRATEGY = "resourcing_strategy";
